(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lae-resource-product"]) return;
  try {
    
  (function () {
    var YT_API = 'https://www.youtube.com/iframe_api';
    var PDFJS_LIB = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

    var ytQueue = [], ytLoading = false;
    function loadYouTubeApi(cb) {
      if (window.YT && window.YT.Player) { cb(); return; }
      ytQueue.push(cb);
      if (ytLoading) return; ytLoading = true;
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') { try { prev(); } catch (e) {} }
        var q = ytQueue.slice(); ytQueue = [];
        q.forEach(function (fn) { try { fn(); } catch (e) {} });
      };
      var s = document.createElement('script'); s.src = YT_API; document.head.appendChild(s);
    }

    var pdfQueue = [], pdfLoading = false;
    function loadPdfJs(cb) {
      if (window.pdfjsLib) { cb(); return; }
      pdfQueue.push(cb);
      if (pdfLoading) return; pdfLoading = true;
      var s = document.createElement('script');
      s.src = PDFJS_LIB;
      s.onload = function () {
        try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; } catch (e) {}
        var q = pdfQueue.slice(); pdfQueue = [];
        q.forEach(function (fn) { try { fn(); } catch (e) {} });
      };
      s.onerror = function () { pdfQueue = []; };
      document.head.appendChild(s);
    }

    function shuffle(arr) { var a = arr.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

    function initRoot(root) {
      if (!root || root.dataset.laeReady === '1') return; root.dataset.laeReady = '1';
      var cfg; try { cfg = JSON.parse(root.querySelector('[data-lae-config]').textContent); } catch (e) { return; }
      var files = cfg.files || {}, L = cfg.labels || {};
      var maxLevels = parseInt(cfg.maxLevels, 10) || 6;
      var profiles = ['eleve', 'prof'];
      var avail = {}, anyAvail = false;
      profiles.forEach(function (p) { avail[p] = {}; for (var l = 1; l <= maxLevels; l++) { var has = !!(files[p] && files[p][String(l)]); avail[p][l] = has; if (has) anyAvail = true; } });
      function firstLevel(p) { for (var l = 1; l <= maxLevels; l++) { if (avail[p][l]) return l; } return null; }
      var profileHasAny = {}; profiles.forEach(function (p) { profileHasAny[p] = firstLevel(p) !== null; });

      var selectorEl = root.querySelector('[data-lae-selector]');
      var actionEl = root.querySelector('[data-lae-action]');
      var emptyEl = root.querySelector('[data-lae-empty]');
      if (!anyAvail) { if (emptyEl) emptyEl.hidden = false; if (selectorEl) selectorEl.hidden = true; if (actionEl) actionEl.hidden = true; return; }

      var toggleEl = root.querySelector('[data-lae-toggle]');
      var profileBtns = root.querySelectorAll('[data-lae-profile]');
      var levelBtns = root.querySelectorAll('[data-lae-level]');
      var downloadEl = root.querySelector('[data-lae-download]');
      var downloadText = root.querySelector('[data-lae-download-text]');

      var unlocked = {};
      function ckey(p, l) { return p + '-' + l; }
      function isUnlocked(p, l) { return cfg.isSubscriber === true || unlocked[ckey(p, l)] === true; }

      var state = { profile: (cfg.defaultProfile && profileHasAny[cfg.defaultProfile]) ? cfg.defaultProfile : 'eleve', level: null };

      // ---------- Cover + PDF preview on hover ----------
      var preview = (function () {
        var wrap = root.querySelector('[data-lae-preview]');
        if (!wrap) return { apply: function () {} };
        var stage   = wrap.querySelector('[data-lae-stage]');
        var canvas  = wrap.querySelector('[data-lae-canvas]');
        var loader  = wrap.querySelector('[data-lae-loader]');
        var pvEmpty = wrap.querySelector('[data-lae-preview-empty]');
        var btnPrev = wrap.querySelector('[data-lae-pv-prev]');
        var btnNext = wrap.querySelector('[data-lae-pv-next]');
        var btnQuit = wrap.querySelector('[data-lae-pv-quit]');
        var counter = wrap.querySelector('[data-lae-pv-count]');
        var ctx = canvas.getContext('2d');
        var isTouch = window.matchMedia('(hover: none)').matches;

        var docCache = {};
        var targetUrl = '';
        var currentUrl = null;
        var currentDoc = null;
        var pageNum = 1;
        var numPages = 0;
        var renderTask = null;
        var reqToken = 0;
        var previewing = false;

        stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });

        function setLoading(on) { loader.classList.toggle('is-visible', !!on); }
        function updateNav() {
          counter.textContent = numPages ? (pageNum + ' / ' + numPages) : '– / –';
          btnPrev.disabled = pageNum <= 1 || !numPages;
          btnNext.disabled = pageNum >= numPages || !numPages;
        }
        function showEmpty(on) {
          pvEmpty.hidden = !on;
          if (on) { numPages = 0; updateNav(); setLoading(false); }
        }

        function renderPage(n, token) {
          if (!currentDoc) return;
          currentDoc.getPage(n).then(function (page) {
            if (token !== reqToken) return;
            var dpr = Math.min(window.devicePixelRatio || 1, 2);
            var cssWidth = stage.clientWidth || 600;
            var baseViewport = page.getViewport({ scale: 1 });
            var scale = (cssWidth / baseViewport.width) * dpr;
            var viewport = page.getViewport({ scale: scale });
            canvas.width = Math.floor(viewport.width);
            canvas.height = Math.floor(viewport.height);
            if (renderTask) { try { renderTask.cancel(); } catch (e) {} }
            renderTask = page.render({ canvasContext: ctx, viewport: viewport });
            renderTask.promise.then(function () {
              if (token !== reqToken) return;
              renderTask = null;
              setLoading(false);
              updateNav();
            }).catch(function () { /* cancelled */ });
          }).catch(function () { if (token === reqToken) showEmpty(true); });
        }

        function loadUrl(url) {
          var token = ++reqToken;
          if (!url) { showEmpty(true); return; }
          showEmpty(false);
          setLoading(true);
          currentUrl = url;
          currentDoc = null;
          pageNum = 1;
          numPages = 0;
          updateNav();
          loadPdfJs(function () {
            if (token !== reqToken) return;
            if (!window.pdfjsLib) { showEmpty(true); return; }
            if (docCache[url]) {
              currentDoc = docCache[url];
              numPages = currentDoc.numPages;
              updateNav();
              renderPage(1, token);
              return;
            }
            window.pdfjsLib.getDocument({ url: url }).promise.then(function (doc) {
              if (token !== reqToken) return;
              docCache[url] = doc;
              currentDoc = doc;
              numPages = doc.numPages;
              updateNav();
              renderPage(1, token);
            }).catch(function () { if (token === reqToken) showEmpty(true); });
          });
        }

        function enterPreview() {
          if (previewing) return;
          previewing = true;
          stage.classList.add('is-previewing');
          if (targetUrl !== currentUrl || !currentDoc) { loadUrl(targetUrl); }
        }
        function exitPreview() {
          if (!previewing) return;
          previewing = false;
          stage.classList.remove('is-previewing');
          showEmpty(false);
          setLoading(false);
        }

        function go(delta) {
          if (!currentDoc) return;
          var n = pageNum + delta;
          if (n < 1 || n > numPages) return;
          pageNum = n;
          setLoading(true);
          renderPage(n, reqToken);
        }

        btnPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
        btnNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
        if (btnQuit) btnQuit.addEventListener('click', function (e) { e.stopPropagation(); exitPreview(); });

        if (isTouch) {
          stage.addEventListener('click', function () { if (!previewing) enterPreview(); });
          var touchX = null;
          stage.addEventListener('touchstart', function (e) {
            if (e.touches.length === 1) touchX = e.touches[0].clientX;
          }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            if (touchX === null || !previewing) return;
            var dx = e.changedTouches[0].clientX - touchX;
            touchX = null;
            if (Math.abs(dx) < 40) return;
            if (dx < 0) { go(1); } else { go(-1); }
          }, { passive: true });
        } else {
          stage.addEventListener('mouseenter', enterPreview);
          stage.addEventListener('mouseleave', exitPreview);
        }

        var resizeTimer = null;
        window.addEventListener('resize', function () {
          if (resizeTimer) clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            if (currentDoc && previewing) renderPage(pageNum, reqToken);
          }, 250);
        });

        return {
          apply: function (profile, level) {
            targetUrl = (files[profile] && files[profile][String(level)]) || '';
            if (previewing && targetUrl !== currentUrl) { loadUrl(targetUrl); }
          }
        };
      })();

      // ---------- Spotlight (highlight unlocked download button) ----------
      var spotlightEl = root.querySelector('[data-lae-spotlight]');
      var spotlightTimer = null;
      function endSpotlight() {
        if (spotlightTimer) { clearTimeout(spotlightTimer); spotlightTimer = null; }
        if (spotlightEl) {
          spotlightEl.classList.remove('is-visible');
          spotlightEl.hidden = true;
        }
        downloadEl.classList.remove('is-spotlight');
        document.removeEventListener('click', onSpotlightClick, true);
      }
      function onSpotlightClick() { endSpotlight(); }
      function showSpotlight() {
        if (!spotlightEl) return;
        spotlightEl.hidden = false;
        requestAnimationFrame(function () { spotlightEl.classList.add('is-visible'); });
        downloadEl.classList.add('is-spotlight');
        try { downloadEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        setTimeout(function () { document.addEventListener('click', onSpotlightClick, true); }, 400);
        spotlightTimer = setTimeout(endSpotlight, 8000);
      }

      function chooseInitial() {
        var order = state.profile === 'eleve' ? ['eleve', 'prof'] : ['prof', 'eleve'];
        for (var i = 0; i < order.length; i++) {
          var p = order[i];
          if (avail[p][1]) { state.profile = p; state.level = 1; return; }
          var fl = firstLevel(p);
          if (fl) { state.profile = p; state.level = fl; return; }
        }
      }
      function renderProfile() {
        if (toggleEl) toggleEl.setAttribute('data-active', state.profile);
        profileBtns.forEach(function (b) {
          var p = b.getAttribute('data-lae-profile'); var on = p === state.profile;
          b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.disabled = !profileHasAny[p];
        });
      }
      function renderLevels() {
        levelBtns.forEach(function (b) {
          var lvl = parseInt(b.getAttribute('data-lae-level'), 10); var ok = avail[state.profile][lvl];
          b.disabled = !ok; b.classList.toggle('is-active', ok && lvl === state.level); b.setAttribute('aria-pressed', (ok && lvl === state.level) ? 'true' : 'false');
        });
      }
      function refreshAction() {
        var url = (files[state.profile] && files[state.profile][String(state.level)]) || '';
        downloadEl.classList.remove('is-cta', 'is-locked', 'is-download');
        if (!url) {
          downloadEl.setAttribute('href', '#'); downloadEl.setAttribute('aria-disabled', 'true'); downloadEl.setAttribute('tabindex', '-1');
          downloadEl.classList.add('is-locked'); downloadEl.removeAttribute('download');
          if (downloadText) downloadText.textContent = L.unavailable || 'Indisponible';
          return;
        }
        if (isUnlocked(state.profile, state.level)) {
          downloadEl.setAttribute('href', url); downloadEl.setAttribute('aria-disabled', 'false'); downloadEl.setAttribute('tabindex', '0');
          downloadEl.setAttribute('download', ''); downloadEl.setAttribute('target', '_blank'); downloadEl.classList.add('is-download');
          if (downloadText) downloadText.textContent = L.download || 'Télécharger le PDF';
        } else {
          downloadEl.setAttribute('href', '#'); downloadEl.setAttribute('aria-disabled', 'false'); downloadEl.setAttribute('tabindex', '0');
          downloadEl.removeAttribute('download'); downloadEl.removeAttribute('target'); downloadEl.classList.add('is-cta');
          if (downloadText) downloadText.textContent = L.cta || 'Obtenir le PDF gratuitement';
        }
      }
      function setProfile(p) { if (!avail[p] || !profileHasAny[p]) return; state.profile = p; if (!avail[p][state.level]) state.level = avail[p][1] ? 1 : firstLevel(p); renderProfile(); renderLevels(); refreshAction(); preview.apply(state.profile, state.level); }
      function setLevel(l) { if (!avail[state.profile][l]) return; state.level = l; renderLevels(); refreshAction(); preview.apply(state.profile, state.level); }

      profileBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; setProfile(b.getAttribute('data-lae-profile')); }); });
      levelBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; setLevel(parseInt(b.getAttribute('data-lae-level'), 10)); }); });

      downloadEl.addEventListener('click', function (e) {
        if (downloadEl.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        if (isUnlocked(state.profile, state.level)) { return; }
        e.preventDefault();
        openGate(state.profile, state.level);
      });

      // ---------- Gate modal ----------
      var modal = root.querySelector('[data-lae-modal]');
      var playBtn = modal ? modal.querySelector('[data-lae-play]') : null;
      var statusEl = modal ? modal.querySelector('[data-lae-status]') : null;
      var cover = modal ? modal.querySelector('[data-lae-cover]') : null;
      var adLoading = modal ? modal.querySelector('[data-lae-adloading]') : null;
      var mount = modal ? modal.querySelector('[data-lae-player-mount]') : null;
      var player = null, watchdog = null, order = [], idx = 0, pending = null, visHandler = null, lastFocused = null, apiTimer = null, autoplayTimer = null;
      var liveEl = root.querySelector('[data-lae-live]');
      var dialogEl = modal ? modal.querySelector('.lae-modal__dialog') : null;

      function clearWatchdog() { if (watchdog) { clearTimeout(watchdog); watchdog = null; } }
      function armWatchdog() { clearWatchdog(); watchdog = setTimeout(function () { watchdog = null; nextVideo(); }, 12000); }
      function clearApiTimer() { if (apiTimer) { clearTimeout(apiTimer); apiTimer = null; } }
      function clearAutoplayTimer() { if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; } }
      function setAdLoading(on) { if (adLoading) adLoading.hidden = !on; }

      function freshMount() {
        var wrap = modal.querySelector('[data-lae-player-wrap]');
        Array.prototype.slice.call(wrap.querySelectorAll('[data-lae-player-mount], iframe')).forEach(function (m) { try { m.remove(); } catch (e) {} });
        var f = document.createElement('div'); f.className = 'lae-player__mount'; f.setAttribute('data-lae-player-mount', '');
        wrap.insertBefore(f, wrap.firstChild); mount = f;
      }
      function buildPlayer(id) {
        try {
          player = new YT.Player(mount, {
            videoId: id, width: '100%', height: '100%',
            playerVars: { autoplay: 1, controls: 0, disablekb: 1, fs: 0, modestbranding: 1, rel: 0, iv_load_policy: 3, playsinline: 1, origin: window.location.origin },
            events: {
              onReady: function () {
                clearApiTimer();
                try { if (player && player.playVideo) player.playVideo(); } catch (e) {}
                armWatchdog();
                clearAutoplayTimer();
                autoplayTimer = setTimeout(function () {
                  try {
                    if (player && player.getPlayerState && player.getPlayerState() !== window.YT.PlayerState.PLAYING) {
                      clearWatchdog();
                      setAdLoading(false);
                      if (playBtn) playBtn.hidden = false;
                    }
                  } catch (e) {}
                }, 2500);
              },
              onStateChange: function (e) {
                var S = window.YT.PlayerState;
                if (e.data === S.PLAYING) {
                  clearWatchdog(); clearAutoplayTimer();
                  setAdLoading(false);
                  if (playBtn) playBtn.hidden = true;
                  if (cover) cover.hidden = true;
                  if (statusEl) statusEl.textContent = '';
                }
                if (e.data === S.ENDED) { clearWatchdog(); adEnded(); }
              },
              onError: function () { clearWatchdog(); nextVideo(); }
            }
          });
        } catch (err) { nextVideo(); }
      }
      function nextVideo() {
        clearWatchdog(); clearAutoplayTimer(); idx++;
        if (idx >= order.length) { failOpen(); return; }
        try { if (player && player.destroy) player.destroy(); } catch (e) {}
        freshMount(); if (playBtn) playBtn.hidden = true; if (cover) cover.hidden = false; setAdLoading(true); buildPlayer(order[idx]);
      }
      // No playable ad (all errored / API blocked): don't trap the user — unlock this combo.
      function failOpen() { if (pending) unlocked[pending] = true; refreshAction(); closeGate(downloadEl); showSpotlight(); }
      function adEnded() {
        if (pending) unlocked[pending] = true;
        if (liveEl) liveEl.textContent = L.unlocked || '';
        refreshAction(); closeGate(downloadEl); showSpotlight();
      }

      function onVisibility() {
        if (!player) return;
        try {
          if (document.hidden) { clearWatchdog(); if (player.pauseVideo) player.pauseVideo(); }
          else if (player.getPlayerState && player.getPlayerState() === 2 && player.playVideo) { player.playVideo(); armWatchdog(); }
        } catch (e) {}
      }

      function getFocusable() {
        if (!dialogEl) return [];
        return Array.prototype.slice.call(dialogEl.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return !el.hidden && !el.disabled && el.offsetParent !== null; });
      }
      function onKeydown(e) {
        if (!modal || modal.hidden) return;
        if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeGate(); return; }
        if (e.key === 'Tab' || e.keyCode === 9) {
          var f = getFocusable(); if (!f.length) { e.preventDefault(); return; }
          var first = f[0], last = f[f.length - 1], active = document.activeElement;
          if (e.shiftKey) { if (active === first || !dialogEl.contains(active)) { e.preventDefault(); last.focus(); } }
          else { if (active === last || !dialogEl.contains(active)) { e.preventDefault(); first.focus(); } }
        }
      }

      function openGate(p, l) {
        if (cfg.isSubscriber) { unlocked[ckey(p, l)] = true; refreshAction(); return; }
        var videos = ((cfg.adVideos) || []).filter(Boolean);
        if (!videos.length || !modal) { unlocked[ckey(p, l)] = true; refreshAction(); return; }
        pending = ckey(p, l); order = shuffle(videos); idx = 0;
        lastFocused = document.activeElement;
        endSpotlight();
        freshMount();
        if (cover) cover.hidden = false; if (playBtn) playBtn.hidden = true; if (statusEl) statusEl.textContent = '';
        setAdLoading(true);
        modal.hidden = false;
        document.documentElement.classList.add('lae-modal-open'); document.body.classList.add('lae-modal-open');
        visHandler = onVisibility; document.addEventListener('visibilitychange', visHandler);
        document.addEventListener('keydown', onKeydown);
        var closeBtn = modal.querySelector('.lae-modal__close'); if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
        // Fail open if the YouTube API script itself never loads (adblocker / CSP / offline).
        clearApiTimer(); apiTimer = setTimeout(function () { if (!player) failOpen(); }, 10000);
        loadYouTubeApi(function () { buildPlayer(order[idx]); });
      }
      function closeGate(focusTarget) {
        clearWatchdog(); clearApiTimer(); clearAutoplayTimer();
        setAdLoading(false);
        if (visHandler) { document.removeEventListener('visibilitychange', visHandler); visHandler = null; }
        document.removeEventListener('keydown', onKeydown);
        try { if (player && player.destroy) player.destroy(); } catch (e) {} player = null;
        if (modal) { freshMount(); modal.hidden = true; }
        document.documentElement.classList.remove('lae-modal-open'); document.body.classList.remove('lae-modal-open');
        pending = null;
        var ft = focusTarget || lastFocused;
        if (ft && ft.focus) { try { ft.focus(); } catch (e) {} }
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (player && player.playVideo) { player.playVideo(); playBtn.hidden = true; if (cover) cover.hidden = true; if (statusEl) statusEl.textContent = ''; armWatchdog(); }
        });
      }
      if (modal) {
        Array.prototype.slice.call(modal.querySelectorAll('[data-lae-cancel]')).forEach(function (el) {
          el.addEventListener('click', function () { closeGate(); });
        });
      }

      chooseInitial(); renderProfile(); renderLevels(); refreshAction();
      preview.apply(state.profile, state.level);
    }

    function initAll() { document.querySelectorAll('[data-lae-root]').forEach(initRoot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector ? e.target.querySelector('[data-lae-root]') : null; if (r) initRoot(r); });
  })();

  } catch(e) { console.error(e); }
})();
})();
